import type { PortalBootstrapData } from '../types/window';

/**
 * Flatten the portal bootstrap into the shape sub-apps read via
 * `getBootstrapData("AccountingHubPortal")`. The portal entry (`portal/src/index.tsx`)
 * OVERWRITES `window.AccountingHubPortal` with exactly this object before mounting, so any
 * server-provided field omitted here is silently dropped before sub-apps run — a whole-field
 * allowlist, not a merge. Every field a sub-app depends on must be listed:
 * - `capabilities` gates CTAs (hidden wrong if lost).
 * - `vsmeReportsBundleUrl` (MIG-015) lets the users screen runtime-mount the reports table;
 *   without it the "Missions en cours" table silently renders empty.
 * - `fileStoreLive` swaps the company page's FEC/DSN import for its "Fichiers" tab.
 */
export const normalizePortalBootstrap = (bootstrap: PortalBootstrapData) => ({
  restUrl: bootstrap.restUrls.accountingHub,
  restUrlVsme: bootstrap.restUrls.vsme,
  nonce: bootstrap.nonce,
  currentUser: bootstrap.currentUser,
  ajaxUrl: '',
  adminUrl: '',
  brand: bootstrap.brand,
  capabilities: bootstrap.capabilities,
  roleOptions: bootstrap.roleOptions ?? [],
  dossierAttributionDefaultScopeMode: bootstrap.dossierAttributionDefaultScopeMode ?? 'all',
  entitlements: bootstrap.entitlements,
  isFecDsnImportEnabled: bootstrap.isFecDsnImportEnabled ?? false,
  fileStoreLive: bootstrap.fileStoreLive ?? false,
  vsmeReportsBundleUrl: bootstrap.vsmeReportsBundleUrl,
});
